// extracted by mini-css-extract-plugin
export var cardWrapper = "_62-0";